import { DateTime } from 'luxon';

import { getTodayDateTime } from 'forms/validators';

import { UpdateOccupationInput } from '../../../types/graph';
import { BasicsFormValues } from '../form/types';

const encodeISODate = (year?: number) => (year ? DateTime.utc(year).toISO() : null);

const buildInput = (values: BasicsFormValues): UpdateOccupationInput => {
  const input: UpdateOccupationInput = {};

  if (values.atLeast30HoursAWeek !== undefined) {
    input.atLeast30HoursAWeek = values.atLeast30HoursAWeek;
  }

  if (values.job?.value !== undefined) {
    input.jobTitleId = parseInt(values.job.value, 10);
  }

  if (values.selfEmployed !== undefined) {
    input.selfEmployed = values.selfEmployed;
    input.corporateStructure = values.corporateStructure;
    input.ownershipStake = values.ownershipStake;
    input.numberOfEmployees = values.numberOfEmployees;
    input.numberOfPartners = values.numberOfPartners;
    input.companyFoundedAt = encodeISODate(values.companyFoundedAt);
    input.becameOwnerAt = encodeISODate(values.becameOwnerAt);

    if (values.companyFoundedAt && values.companyFoundedAt >= getTodayDateTime().year - 1) {
      input.annualIncomeBeforeCompany = values.annualIncomeBeforeCompany;
    }
  }

  if (values.disabilityInsuranceStatus !== undefined) {
    input.disabilityInsuranceStatus = values.disabilityInsuranceStatus;
    input.existingCoverage = values.existingCoverage;
    input.disabilityInsuranceSource = values.disabilityInsuranceSource;
    input.intendToReplace = values.intendToReplace;

    if (values.disabilityInsuranceSource === 'employer') {
      input.employerPaysPremium = values.employerPaysPremium;
    }
  }

  return input;
};

export default buildInput;
